export default __webpack_public_path__ + "static/media/CNo.48-2.81a45068.jpg";